module.exports = __webpack_public_path__ + "static/scale-model-of-spadena-house-in-los-angeles-california-2356bd9d4e8228de798dce31f4514ce2.png";